import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

// Ticket 196: the top-bar "+" menu links to `<page>?new=1`. Open the page's
// own "new" dialog for that, then take the flag back out of the URL so a
// reload or Back does not reopen it. Keyed on the flag, not on mount, so it
// also works when the page is already on screen and only the URL changes.
export default function useOpenNewFromUrl(openNew) {
  const [params, setParams] = useSearchParams();
  const wanted = params.get('new') === '1';
  const openRef = useRef(openNew);
  openRef.current = openNew;
  useEffect(() => {
    if (!wanted) return;
    openRef.current();
    setParams((prev) => {
      const next = new URLSearchParams(prev);
      next.delete('new');
      return next;
    }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wanted]);
}
